import { Play } from "lucide-react";
import type { ArticleListItem } from "@/types/api";
import { cn, resolveMediaUrl } from "@/lib/utils";

export function articleLeadImage(
  article: Pick<ArticleListItem, "has_video" | "video_poster" | "cover" | "cover_thumb">,
) {
  if (article.has_video) {
    const poster = resolveMediaUrl(article.video_poster);
    if (poster) return poster;
  }
  return resolveMediaUrl(article.cover_thumb || article.cover);
}

export function VideoCardBadge({ compact = false, className }: { compact?: boolean; className?: string }) {
  return (
    <span
      className={cn(
        "pointer-events-none absolute z-10 inline-flex items-center gap-1 rounded bg-brand-chrome font-bold uppercase tracking-wider text-white shadow",
        compact ? "bottom-1 left-1 px-1.5 py-0.5 text-[9px]" : "bottom-2 left-2 px-2 py-1 text-[11px]",
        className,
      )}
    >
      <Play className={compact ? "h-2.5 w-2.5 fill-current" : "h-3.5 w-3.5 fill-current"} aria-hidden />
      Vídeo
    </span>
  );
}
